import React from 'react';
import block from 'bem-cn-lite';
import { I18n } from 'react-i18next';

class TrialTooltip extends React.Component {
    render() {
        const b = block('TrialTooltip')
        const {width} = this.props;

        return (
            <I18n ns={ ['global'] }>
            {
                (t) => (
                    <div
                        className={b()}
                        style={{width: width}}>
                        {t('global:freeTrialTooltip')}
                    </div>
                )
            }
            </I18n>
        )
    }
}

export default TrialTooltip;